const API_URL = 'https://jlha9j6m02.execute-api.us-east-1.amazonaws.com/prod/data';

export const saveData = async (data) => {
  const response = await fetch(API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Origin': window.location.origin,
    },
    mode: 'cors',
    credentials: 'omit',
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    const message = body?.error || `Registration failed (${response.status}). Please try again later.`;
    console.error('API Error:', message);
    throw new Error(message);
  }

  return response.json();
};

export const checkIn = async (id, checkedIn = true) => {
  try {
    const response = await fetch(API_URL, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Origin': window.location.origin,
      },
      mode: 'cors',
      credentials: 'omit',
      body: JSON.stringify({ id, checkedIn }),
    });

    if (!response.ok) {
      throw new Error('Check-in failed. Please try again.');
    }

    return response.json();
  } catch (error) {
    console.error('API Error:', error);
    throw new Error('Failed to check in. Please check your internet connection and try again.');
  }
};

export const getData = async () => {
  try {
    const response = await fetch(API_URL, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Origin': window.location.origin,
      },
      mode: 'cors',
      credentials: 'omit',
    });
    
    if (!response.ok) {
      throw new Error('Failed to fetch data. Please try again later.');
    }
    
    return response.json();
  } catch (error) {
    console.error('API Error:', error);
    throw new Error('Failed to connect to the server. Please check your internet connection and try again.');
  }
};

export const saveAppointment = async (data) => {
  const response = await fetch(API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Origin': window.location.origin,
    },
    mode: 'cors',
    credentials: 'omit',
    body: JSON.stringify({ ...data, type: 'appointment' }),
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    const message = body?.error || `Appointment request failed (${response.status}). Please try again later.`;
    console.error('API Error:', message);
    throw new Error(message);
  }

  return response.json();
};
